export default "__VITE_ASSET___tnjBEz7__"